'use client';

import { FC, useContext } from 'react';
import { FirmGroupSelectorProps } from './FirmGroupSelector.types';
import { Flex, Select } from '@/_components';
import { FirmSettingsContext } from '@/_contexts/FirmSettingsProvider';
import styles from './FirmGroupSelector.module.css';

export const FirmGroupSelector: FC<FirmGroupSelectorProps> = ({
  isDisabled,
  onChange,
  value,
}) => {
  const { firmGroupOptions } = useContext(FirmSettingsContext);

  return (
    <Flex>
      <Select
        isRequired={true}
        items={firmGroupOptions}
        label="Firm Group"
        placeholder="Select group"
        selectedValue={value}
        isDisabled={isDisabled}
        onChange={onChange}
        className={styles.select}
      />
    </Flex>
  );
};
